"use client";

import Emblem from '@/app/components/emblem';
import Title from '@/app/components/title';
import Link from 'next/link';
import React from 'react';
import { usePathname } from "next/navigation";
import {getStrapiURL} from "../../../helper/image-helper";

interface EmblemsProps {
    data: {
        title: string;
        region: Array<{
            name: string;
            link: string;
            image: {
                url: string;
            };
        }>;
    };
}


const Emblems: React.FC<EmblemsProps> = ({ data }) => {

    const pathname = usePathname();
    const isEn = pathname.startsWith("/en");

    const getFullPath = (url: string) => `${isEn ? '/en' : ''}/${url}`;

    return (
        <section className="bg-[#f5f6fe] pt-12 pb-[128px] mt-[116px] max-[576px]:mt-[0] max-[576px]:pt-[40px] max-[576px]:pb-[64px]">
            <div className="container">
                <Title text={data.title} position='left' fontSize='text-[38px]'/>
                <div className="flex gap-[70px] gap-y-[56px] max-[576px]:gap-[24px] max-[576px]:gap-y-[16px] flex-wrap pt-14 justify-between max-[576px]:pt-[28px]">
                    {data.region.map((item, index) => {
                        const fullPath = getFullPath(item.link);
                        return (
                            <Link key={index} href={fullPath}>
                                <Emblem icon={getStrapiURL(item.image?.url)} name={item.name}/>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </section>
    )
}

export default Emblems